
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shoppingcart/[[...slug]]",
      function () {
        return require("private-next-pages/shoppingcart/[[...slug]].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shoppingcart/[[...slug]]"])
      });
    }
  